/** Returns string without extra spaces, e.g. ' foo   bar ' -> 'foo bar' */
const squeeze = (str) => {
    if (str == null)
        return '';
    return str.replace(/\s+/g, ' ').trim();
};
const squeezeValues = (values, separator = ' ') => {
    return values
        .filter((value) => value != null)
        .map((value) => (typeof value === 'string' ? squeeze(value) : value))
        .join(separator)
        .trim();
};
export const formatString = {
    squeeze,
    squeezeValues,
};
